import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../lib/api';
import { useDatos, useSesion } from '../lib/sesion';
import { Tarjeta, Aviso } from './ui';
import { ESTADO_ETIQUETA } from '../lib/formato';
import type { Estado } from '../lib/tipos';

export function useTareasPendientes() {
  const { usuario } = useSesion();
  const location = useLocation();
  const state = useDatos(
    (s) =>
      usuario?.role === 'SALESPERSON'
        ? api.get<{
            rows: Array<{ id: string; publicCode: string; status: Estado }>;
            total: number;
          }>('/me/pending-tasks', s)
        : Promise.resolve({ rows: [], total: 0 }),
    [usuario?.id, location.pathname],
  );
  useEffect(() => {
    const refresh = () => state.recargar();
    window.addEventListener('tareas-actualizadas', refresh);
    const timer = setInterval(refresh, 60000);
    return () => {
      clearInterval(timer);
      window.removeEventListener('tareas-actualizadas', refresh);
    };
  }, [state.recargar]);
  return state;
}
export function TareasPendientes() {
  const { datos, error } = useTareasPendientes();
  return (
    <Tarjeta titulo={`Tareas pendientes (${datos?.total ?? 0})`}>
      {error && <Aviso tono="error">{error}</Aviso>}
      {!datos?.rows.length ? (
        <p className="sutil">No tiene valoraciones ni seguimientos pendientes.</p>
      ) : (
        <ul>
          {datos.rows.map((r) => (
            <li key={r.id}>
              <Link to={`/solicitudes/${r.id}`}>
                {r.publicCode} · {ESTADO_ETIQUETA[r.status]}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Tarjeta>
  );
}
